import { render, staticRenderFns } from "./blindIndex.vue?vue&type=template&id=dac6729e"
import script from "./blindIndex.vue?vue&type=script&lang=js"
export * from "./blindIndex.vue?vue&type=script&lang=js"
import style0 from "./blindIndex.vue?vue&type=style&index=0&id=dac6729e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports